export default __webpack_public_path__ + "static/media/work2image2.c785f5d2.png";